import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "C:\\app\\Workspace\\jsws_2_frontend\\src\\app\\[[...slug]]\\client.jsx");
